import { createAction } from 'redux-actions'

export const setSelectedRetailerId = createAction(
  'CREATE_ORDER_TEMPLATE_MODAL/SET_SELECTED_RETAILER_ID',
)
export const changeRetailerSearchText = createAction(
  'CREATE_ORDER_TEMPLATE_MODAL/CHANGE_RETAILER_SEARCH_TEXT',
)
